import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IEssentialsModule } from '@devinforius/i-essentials';
import { IScanModule } from '@devinforius/i-scan';
import { ActionCardComponent } from './components/action-card/action-card.component';
import { PipesModule } from '../_pipes/@pipes.module';
import { ScrollPanelModule } from 'primeng/scrollpanel';
@NgModule({
  declarations: [ActionCardComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    /*iCompos*/
    IEssentialsModule,
    IScanModule,
    /* PrimeNg*/
    ScrollPanelModule,
  ],
  exports: [
    /*iCompos*/
    IEssentialsModule,
    IScanModule,
    ActionCardComponent,
  ],
})
export class SharedModule {}
